import { IconButton, Radio, RadioGroup, Stack, Text } from '@chakra-ui/react';
import { HiChevronLeft } from 'react-icons/hi';

import { QuoteFilters } from '.';

type Props = {
  filters: QuoteFilters;
  handleFilterChange: (key: string) => (nextValue: string) => void;
  resetView: () => void;
};

export const SortFilter = ({ filters, handleFilterChange, resetView }: Props) => {
  return (
    <Stack>
      <Stack direction="row" align="center" spacing="2">
        <IconButton
          aria-label="Go back"
          icon={<HiChevronLeft />}
          variant="link"
          size="sm"
          display={{ base: 'flex', md: 'none' }}
          minW="auto"
          onClick={resetView}
        />
        <Text textStyle="label"></Text>
      </Stack>

      <RadioGroup value={filters?.sort} onChange={handleFilterChange('sort')}>
        <Stack>
          <Radio value="Cheapest">Cheapest</Radio>
          <Radio value="Fastest">Fastest</Radio>
        </Stack>
      </RadioGroup>
    </Stack>
  );
};
